export default __webpack_public_path__ + "static/team-3-6f43fd6a98bdaa46188582a8c03f69a1.png";